import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client } from "../client";

export const useAdminTikTokAds = (merchantId: string) => {
  return useQuery({
    queryKey: ["admin", "tiktok-ads", merchantId],
    queryFn: async () => {
      const res = await client.admin["tiktok-ads"][":merchantId"].$get({ param: { merchantId } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!merchantId,
  });
};
